<template>
    <div class="date-picker">
        <input type="date" class="form-control text-center text-lg-left" :class="{ 'disabled-input': disabled }" ref="datePicker" v-model="mutableValue" :name="name" />
    </div>
</template>

<script>
import { localeToSelect } from '../../common/flatpickrlocalizer';
import lang from '../../../shared/mixins/lang';
import flatpickr from 'flatpickr';
import moment from 'moment';
require('flatpickr/dist/themes/light.css');
require('../../../../../stylesheets/vendor/flatpickr/themes/light.css');

export default {
    mixins: [lang],
    props: {
        value: {
            required: true,
            default: null,
        },
        displayFormat: {
            type: String,
            default: 'M j, Y',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            picker: null,
            mutableValue: this.value,
            focusedInput: null,
        };
    },
    watch: {
        //workaround for disabled inputs not updating across siblings
        disabled() {
            if (!this.disabled) {
                $(this.$refs.datePicker).siblings('.disabled-input').removeClass('disabled-input');
            }
        },
        mutableValue(newValue) {
            this.$emit('input', newValue);
            this.$emit('dateSelected', newValue);
        },
        value(newValue) {
            this.picker && this.picker.setDate(newValue, true);
        },
    },
    methods: {
        transformDates(dates) {
            return dates.map((date) => {
                return moment(date).format('YYYY-MM-DD');
            });
        },
        config() {
            let config = {
                altInput: true,
                minDate: '01-01-1900',
                maxDate: moment().startOf('day').toDate(),
                defaultDate: this.value,
                altFormat: this.displayFormat,
                position: 'center',
                locale: localeToSelect,
            };

            return config;
        },
        open() {
            this.picker && this.picker.open();
        },
    },
    mounted() {
        if (!this.picker) {
            flatpickr.l10ns.default.firstDayOfWeek = 1;

            this.picker = flatpickr(this.$refs.datePicker, this.config());
        }
    },
    beforeDestroy() {
        if (this.picker) {
            this.picker.destroy();
            this.picker = null;
        }
    },
};
</script>
<style lang="scss">
.date-picker {
    input {
        min-height: 100%;
    }

    .disabled-input {
        pointer-events: none;
    }
}
</style>
